import { FormGroup, ControlContainer } from '@angular/forms';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { EnfantService } from './services/enfant.service';
import { EnfantForm, EnfantModel } from './models/enfant.model';
import { CcdBoutonModel } from '@cnaf.usagers.appli/cnaf-commons-dral'
import { RessourcesEnfantModelAdapter, RessourcesEnfantModel } from '../ressources-enfant/models/ressources-enfant.model';

@Component({
  selector: 'app-enfant',
  templateUrl: './enfant.component.html'
})
export class EnfantComponent implements OnInit, OnDestroy, AfterContentChecked {

  /**
   * Nom du formulaire associé au composant
   */
  @Input() name : string;

  /**
   * reçoit le code postale au format XXXXX + libellé 
   * exemple : 78000 VERSAILLE
   */
  @Input() codePostal: string; // TODO : Renomer le champ s'il ne contient pas que le code postal....

  /**
   * reçoit l'objet de l'enfant en cours
   */
  @Input() enfant: EnfantModel;

  /**
  * Objet sitEnfantEvent renvoyé au parent
  */
  @Output() enfantEvent = new EventEmitter<EnfantModel>();
  
  /**
  * Formulaire du composant
  */
  enfantForm : FormGroup<EnfantForm>;

  libelleIndexEnfant : string;

  /**
   * Paramétrage du radio bouton de type "Oui / Non"
   */
  QUESTION_OUI_NON: Array<CcdBoutonModel> = [
    {code: "true", libelle: "Oui"},
    {code: "false", libelle: "Non"}
  ];

  /**
   * Paramétrage du radio bouton de type "Oui / Non"
   */
  QUESTION_SIT_PRO: Array<CcdBoutonModel> = [
    {code: "ETU", libelle: "Etudiant"},
    {code: "APPRENTI", libelle: "Apprenti"},
    {code: "SALARIE_CP", libelle: "Salarié"}
  ];

  valeurMoins21ans: string;

  valeurRevenue12DernierMois: string;

  afficherSitPro: boolean;

  /**
   * Age maximum déterminé en fonction du code postal
   */
  ageMax : number;

  /**
   * Constructeur bloc enfant
   * @param enfantService 
   * @param controlContainer 
   * @param cd
   */
  constructor(
    private readonly enfantService: EnfantService,
    private readonly controlContainer: ControlContainer,
    private readonly cd: ChangeDetectorRef
  ) {}

  /**
   * init du component : 
   * - Détermination de l'age max de l'enfant en fonction du code postal
   * - Récupération des valeurs associées aux boutons radio en provenance du bean enfant
   */
  ngOnInit(): void {
    this.enfantForm = new FormGroup<EnfantForm>({});
    const parentForm = this.controlContainer?.control as FormGroup;
    parentForm.addControl(this.name, this.enfantForm);

    this.ageMax = this.enfantService.retourneAgeMaxEnfant(this.codePostal);

    this.libelleIndexEnfant = this.enfantService.getLibelle(this.enfant.id);
    if (this.enfant.moins21ans !== null && this.enfant.moins21ans !== undefined) {
      this.valeurMoins21ans = this.enfant.moins21ans.toString();
    }
    if (this.enfant.revenue12DernierMois  !== null && this.enfant.revenue12DernierMois!== undefined) {
      this.valeurRevenue12DernierMois = this.enfant.revenue12DernierMois.toString();
    }
  }

  /**
   * Evenement appelé en sortant du component
   */
  ngOnDestroy(): void {
    const parentForm = this.controlContainer?.control as FormGroup;
    parentForm.removeControl(this.name);
  }

  /**
   * On force la mise à jour des event dans le formulaire pour éviter les effets de bords et log d'erreur
   */
  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  /**
   * Evenement question age max
   * @param $nouvelleValeur nouvelle valeur récupérée du radio bouton moins21ans
   */
  dataChangeQuestionAgeMax($nouvelleValeur : string) {
    this.valeurMoins21ans = $nouvelleValeur;
    this.enfant.moins21ans = (this.valeurMoins21ans === "true");
    this.enfant.revenue12DernierMois = undefined;
    this.valeurRevenue12DernierMois = null;
    this.enfantEvent.emit(this.enfant);
  }

  /**
   * Evenement question revenue dernier mois
   * @param $nouvelleValeur nouvelle valeur récupérée du radio bouton RevenueDernierMois
   */
  dataChangeQuestionRevenueDernierMois($nouvelleValeur : string) {
    this.valeurRevenue12DernierMois = $nouvelleValeur;
    this.enfant.revenue12DernierMois = (this.valeurRevenue12DernierMois === "true");    
    this.enfantEvent.emit(this.enfant);
  }

  /**
   * Evenement dans les ressources 
   * @param $nouvelleValeur 
   */
  dataChangeRessources($nouvelleValeur : RessourcesEnfantModel) {
    this.enfant.ressources = $nouvelleValeur;
    this.conditionAffichageSitPro();
    this.enfantEvent.emit(this.enfant);
  }

  /**
   * Conditionne l'affichage bloc site pro
   * Il faut que la rubrique salaire soit rempli, valid et que les autres élements rubriques soient checked=false et valid=false
   * @returns Vrai si on a les sitpro
   */
  conditionAffichageSitPro() : boolean {
    // TO DO IMPLEMENTER
    const ressAdapter = new RessourcesEnfantModelAdapter(this.enfant.ressources);
    this.afficherSitPro = 
      ressAdapter.salaire!=null && 
      ressAdapter.isSalaireDefini && 
      !ressAdapter.isAllocationChomageDefini && 
      !ressAdapter.isRevenuOuDefinitTravailleurDefini;

    return this.afficherSitPro;
  }
}
